import { render, staticRenderFns } from "./recipients-modal-export-db.vue?vue&type=template&id=1c46a777&"
import script from "./recipients-modal-export-db.vue?vue&type=script&lang=js&"
export * from "./recipients-modal-export-db.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports